// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__209hE","spinner__icon":"styles_spinner__icon__2pU-I"};